/** =========================================================
 * Module: animate-enabled.js
 * Enable or disables ngAnimate for element with directive
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .directive('animateEnabled', animateEnabled);

  animateEnabled.$inject = ['$animate'];

  function animateEnabled($animate) {
    var directive = {
      link: link,
      restrict: 'A'
    };

    return directive;

    function link(scope, element, attrs) {
      scope.$watch(function () {
        return scope.$eval(attrs.animateEnabled, scope);
      }, function (newValue) {
        $animate.enabled(!!newValue, element);
      });
    }
  }
})();
